import contracts from './contracts'
import { FarmConfig, QuoteToken } from './types'

const farms: FarmConfig[] = [
  {
    pid: 10,
    risk: 5,
    lpSymbol: 'TRIB-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x834276c04005b11985c5d33b411e061ade45c881',
    },
    tokenSymbol: 'TRIB',
    tokenAddresses: {
      97: '',
      56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 11,
    risk: 5,
    lpSymbol: 'TRIB-BUSD LP',
    lpAddresses: {
      97: '',
      56: '0x58c49e50dfa42d06df426fcf293919532cd7b945',
    },
    tokenSymbol: 'TRIB',
    tokenAddresses: {
      97: '',
      56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 12,
    risk: 5,
    lpSymbol: 'TRIB-ETH LP',
    lpAddresses: {
      97: '',
      56: '0xe5d48f3c76b890deea586bd17383f08228463590',
    },
    tokenSymbol: 'ETH',
    tokenAddresses: {
      97: '',
      56: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    },
    quoteTokenSymbol: QuoteToken.CAKE,
    quoteTokenAdresses: contracts.cake,
  },
  {
    pid: 13,
    risk: 5,
    lpSymbol: 'TRIB-BTCB LP',
    lpAddresses: {
      97: '',
      56: '0xfc427ac3dce0bfb3e06f85241e994a1c6d8bd848',
    },
    tokenSymbol: 'BTC',
    tokenAddresses: {
      97: '',
      56: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    },
    quoteTokenSymbol: QuoteToken.CAKE,
    quoteTokenAdresses: contracts.cake,
  },
  {
    pid: 0,
    risk: 5,
    lpSymbol: 'TRIB-BUSD LP',
    lpAddresses: {
      97: '',
      56: '0x94c0be576c723573be3682e06ddde536ce8c5b4b',
    },
    tokenSymbol: 'TRIB',
    tokenAddresses: {
      97: '',
      56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 1,
    risk: 5,
    lpSymbol: 'TRIB-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x4eD23914B853f4d63F5e54ef4c9E15D67656650f',
    },
    tokenSymbol: 'TRIB',
    tokenAddresses: {
      97: '',
      56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 2,
    risk: 5,
    lpSymbol: 'TRIB-BTCB LP',
    lpAddresses: {
      97: '',
      56: '0x6ec824c8932a26739a75909fbfead1250dac85cb',
    },
    tokenSymbol: 'TRIB',
    tokenAddresses: {
      97: '',
      56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    },
    quoteTokenSymbol: QuoteToken.BTCB,
    quoteTokenAdresses: contracts.btcb,
  },
  {
    pid: 3,
    risk: 5,
    lpSymbol: 'TRIB-ETH LP',
    lpAddresses: {
      97: '',
      56: '0x4b6a98ce4db1c138eb8dc4b0e5fd38918a0f8c4e',
    },
    tokenSymbol: 'TRIB',
    tokenAddresses: {
      97: '',
      56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    },
    quoteTokenSymbol: QuoteToken.ETH,
    quoteTokenAdresses: contracts.eth,
  },
  {
    pid: 5,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'TRIB',
    lpAddresses: {
      97: '',
      56: '0x94c0be576c723573be3682e06ddde536ce8c5b4b', // TRIB-BUSD LP
    },
    tokenSymbol: 'TRIB',
    tokenAddresses: {
      97: '',
      56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 4,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'KLING',
    lpAddresses: {
      97: '',
      56: '0xccab9f90176a89894ba3edd34cb9dd9569e00c8d', // KLING-BUSD LP
    },
    tokenSymbol: 'KLING',
    tokenAddresses: {
      97: '',
      56: '0xf6527dF4592BD17cF5c697330F38781fEFE7dEf6',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 6,
    risk: 3,
    isBurnOnly: true,
    lpSymbol: 'BNB-BUSD LP',
    lpAddresses: {
      97: '',
      56: '0x1b96b92314c44b159149f7e0303511fb2fc4774f',
    },
    tokenSymbol: 'BNB',
    tokenAddresses: {
      97: '',
      56: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 7,
    risk: 2,
    isBurnOnly: true,
    lpSymbol: 'BTCB-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x7561eee90e24f3b348e1087a005f78b4c8453524',
    },
    tokenSymbol: 'BTCB',
    tokenAddresses: {
      97: '',
      56: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 8,
    risk: 2,
    isBurnOnly: true,
    lpSymbol: 'ETH-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x70d8929d04b60af4fb9b58713ebcf18765ade422',
    },
    tokenSymbol: 'ETH',
    tokenAddresses: {
      97: '',
      56: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 9,
    risk: 2,
    lpSymbol: 'TRIB-KLING LP',
    lpAddresses: {
      97: '',
      56: '0xa49c1d1da83b225769e7b125ce47cc7b9333805e',
    },
    tokenSymbol: 'TRIB',
    tokenAddresses: {
      97: '',
      56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    },
    quoteTokenSymbol: QuoteToken.KLING,
    quoteTokenAdresses: contracts.kling,
  },
]

export default farms
